import { motion } from 'framer-motion'
import { useChatContext } from '../context/ChatContext.jsx'

function FloatingChat() {
  const { isOpen, openChat } = useChatContext()

  if (isOpen) return null

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 1.0, ease: 'easeOut' }}
      className="fixed right-6 bottom-6 z-40 floating-chat"
    >
      <button
        onClick={openChat}
        className="inline-flex items-center gap-2 px-4 py-2.5 bg-soft-surface border border-soft-rule text-sm text-soft-ink cursor-pointer shadow-[0_4px_14px_rgba(0,0,0,0.04)] hover:shadow-[0_4px_18px_rgba(0,0,0,0.08)] transition-shadow"
        aria-label="Open chat with Mugunth's agent"
      >
        Ask my agent <span aria-hidden="true" className="text-soft-dim">↑</span>
      </button>
    </motion.div>
  )
}

export default FloatingChat
